import { createStore } from 'vuex'
const store = createStore({
  state:{
    imgUrl:'https://file.xribml.cn',
    //状态管理器中定义的数据源
    wallet:{},
    walletInfo:{
      check:'',
      address:'',
    },
  },
  mutations:{
    //同步操作
  },
  actions:{
    //异步操作
  },
  //getters相当于计算属性
  getters:{
  }
})
export default store
